import type { MonospaceAuditLog } from '#layers/data-model/public';
import { RStoreSchema } from '#imports';
import { User } from './user';
import { Workspace } from './workspace';

export const AuditLog = RStoreSchema.withItemType<MonospaceAuditLog>().defineCollection({
	name: 'MonospaceAuditLog',
	scopeId: 'monospace-default',
	meta: {
		defaultFields: [
			'id',
			'timestamp',
			'action',
			'resourceType',
			'resourceId',
			'actorId',
			'actorIp',
			'outcome',
			'collectionId',
			'workspaceId',
		],
		endpoint: 'system/audit-logs',
	},
});

export const AuditLogRelations = RStoreSchema.defineRelations(AuditLog, ({ collection }) => ({
	actor: {
		to: collection(User, {
			on: {
				'MonospaceUser.id': 'MonospaceAuditLog.actorId',
			},
		}),
	},
	workspace: {
		to: collection(Workspace, {
			on: {
				'MonospaceWorkspace.id': 'MonospaceAuditLog.workspaceId',
			},
		}),
	},
}));
